/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { Fragment } from "react";
import { StoryCard } from "../../Molecules/StoryCard";
import { StorycardContent } from "../../Molecules/StorycardContent";
import { HeroImage } from "../../Atoms/HeroImage";
import get from "lodash.get";
import { CollectionName } from "../../Atoms/CollectionName";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { getTextColor } from "../../../utils/utils";
import { collectionToStories } from "@quintype/components";
import PropTypes from "prop-types";
import { StateProvider } from "../../SharedContext";
import "./four-col.m.css";

const FourColGrid = ({ collection, config = {}, getMoreStories, isLoadMoreVisible, isLoading }) => {
  const {
    collectionNameBorderColor = "",
    borderColor = "",
    theme = "",
    border = "",
    collectionNameTemplate = "",
    footerSlotConfig = {},
    footerButton = ""
  } = config;
  const storyItems = collectionToStories(collection);
  if (!storyItems.length) return null;

  const { footerSlot } = footerSlotConfig;
  const footerSlotComp = footerSlot ? footerSlot() : null;
  const textColor = getTextColor(theme);

  const loadMore = async () => {
    if (isLoading) return; // prevent multiple clicks/calls
    const limit = 4;
    const offset = storyItems.length;
    await getMoreStories(offset, limit);
  };

  return (
    <div className="full-width-with-padding arrow-component" style={{ backgroundColor: theme, color: textColor }}>
      <div styleName="four-col-grid">
        <CollectionName
          collection={collection}
          collectionNameTemplate={collectionNameTemplate}
          collectionNameBorderColor={collectionNameBorderColor}
        />
        <div styleName="wrapper">
          {storyItems.map((story, index) => {
            return (
              <Fragment key={`story-4col-${index}-${get(story, ["id"], "0")}`}>
                <div styleName="story-card-wrapper" key={`default-${index}`}>
                  <StoryCard story={story} border={border} theme={theme} isHorizontalMobile>
                    <HeroImage aspectRatio={[[16, 9]]} story={story} isHorizontalMobile />
                    <StorycardContent
                      theme={theme}
                      border={border}
                      borderColor={borderColor}
                      story={story}
                      isHorizontalMobile
                    />
                  </StoryCard>
                </div>
              </Fragment>
            );
          })}
        </div>
        {isLoadMoreVisible && <LoadmoreButton collection={collection} template={footerButton} onClick={loadMore} />}
        {footerSlotComp}
      </div>
    </div>
  );
};

FourColGrid.propTypes = {
  /**  collection is the array of objects which is returning by API  */
  collection: PropTypes.object.isRequired,
  /** The config for the Row */
  config: PropTypes.shape({
    borderColor: PropTypes.string,
    theme: PropTypes.string,
    border: PropTypes.bool,
    slotConfig: PropTypes.array,
    collectionNameTemplate: PropTypes.string,
    footerButton: PropTypes.string,
    collectionNameBorderColor: PropTypes.string
  }),
  getMoreStories: PropTypes.func,
  isLoadMoreVisible: PropTypes.bool,
  isLoading: PropTypes.bool
};

FourColGrid.defaultProps = {
  getMoreStories: () => {},
  isLoadMoreVisible: true,
  isLoading: false
};

export default StateProvider(FourColGrid);
